<template>
  <div class="usersExampleUser">
    <Row type="flex" justify="space-around">
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 1"
        >
          <use xlink:href="#icon-mpai-people_5"></use>
        </svg>
        <div :class="index === 1 ? 'fontStyle' : ''" @click="index = 1">
          大二
        </div>
        <div :class="index === 1 ? 'fontStyle' : ''" @click="index = 1">
          行政管理
        </div>
      </i-col>
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 2"
        >
          <use xlink:href="#icon-mpai-people_3"></use>
        </svg>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          大三
        </div>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          财会专业
        </div>
      </i-col>
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 3"
        >
          <use xlink:href="#icon-mpai-people_9"></use>
        </svg>
        <div :class="index === 3 ? 'fontStyle' : ''" @click="index = 3">
          大四
        </div>
        <div :class="index === 3 ? 'fontStyle' : ''" @click="index = 3">
          国贸专业
        </div>
      </i-col>
    </Row>
    <div v-if="index === 1" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="8" class="pinched">
          <p>
            参加数学建模大赛写论文时需要用到两个数学模型，层次分析法与时间序列分析。虽然通过查看论文大概看懂了其原理,但是不太会实践,想找一个工具实现。时间序列倒是好找,但是软件是收费的,操作流程也不会,层次分析法则是完全找不到工具。唉,太难了！要是有一个免费的,傻瓜式又一站式的工具可以实现这些算法就好了。
          </p>
        </i-col>
        <i-col span="16"></i-col>
      </row>
    </div>
    <div v-else-if="index === 2" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="7"></i-col>
        <i-col span="10" class="pinched">
          <p>
            想要一份大厂offer，但是基本适合自己的岗位都需要数据分析能力。找资料确定了数据分析学习路径，但是发现需要学习的理论和工具太多了，光视频课程就有130多个小时已经满满的一堆难啃的数理书籍。还不算实践的，全力啃下来起码得花一年以上，还不敢保证学习效果。只是想学多一个技能而已，唉，太难了！要是只用学习一个工具就能掌握数据分析就好了。
          </p>
        </i-col>
        <i-col span="7"></i-col>
      </row>
    </div>
    <div v-else-if="index === 3" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="16"></i-col>
        <i-col span="8" class="pinched">
          <p>
            要毕业了，选的论文需要做时间序列分析与线性回归。阅读了很多相关的文献，但是文科专业出身的我对于数学模型实在看不进去。好不容易勉强看懂了分析流程，却发现自己还得学习SPSS或者python编程来实现算法。Boss给的实习工作又太忙了。天啦噜，要我老命了。要是有一个软件能直接输出分析模板，让我不用去翻那么多资料该多好！
          </p>
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 2
    };
  }
};
</script>

<style lang="less" scoped>
.fontStyle {
  color: #2d8cf0;
}
.usersExampleUser {
  padding: 10px 0;
  padding-bottom: 5px;
  width: 100%;
  .users_plane {
    height: 130px;
    text-align: center;
    cursor: pointer;
    .users_plane_img {
      height: 80px;
      width: 100%;
    }
  }
}
.pinchedContent {
  display: flex;
  justify-content: center;
}
.pinchedContext {
  padding: 0 5px;
  max-width: 1500px;
}
.pinchedRight {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedRight:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 70%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedRight:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 70%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedRight > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 30%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinchedleft {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedleft:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 13.5%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedleft:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 13.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedleft > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 86.5%;
  height: 20px;
  background: green;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinched {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinched:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinched:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinched > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
</style>
